<template>
  <div>
    <div v-if="!$vuetify.breakpoint.xsOnly && stock_data.length != 0">
      <draggable v-model="stock_data" @start="drag = true" @end="drag = false">
        <v-data-table
          :headers="headers"
          :items="stock_data"
          hide-default-footer
          class="elevation-1"
          mobile-breakpoint
          item-key="name"
        >
          <template v-slot:body="props">
            <draggable
              :list="props.items"
              tag="tbody"
              :disabled="!is_drag"
              :move="onMoveCallback"
              :clone="onCloneCallback"
              @end="onDropCallback"
              :options="{
                handle: '.drag-handle',
              }"
            >
              <template v-for="item in props.items">
                <!--  -->
                <tr v-if="item" :key="item.id">
                  <td>
                    <div v-if="item.trader_data" class="d-flex">
                      <div class="" v-if="is_drag">
                        <v-btn class="drag-handle" icon>
                          <v-icon>mdi-drag </v-icon>
                        </v-btn>
                      </div>
                      <div>
                        <div class="name d-flex justify-between align-center">
                          <span>
                            {{ item.trader_data.name }}
                          </span>
                          <div>
                            <v-img
                              v-if="item.trader_data.is_sebi_registered"
                              class="ml-1"
                              :src="verified"
                              width="14px"
                            ></v-img>
                            <!-- <v-btn @click="print(item.trader_data)">print</v-btn> -->
                          </div>
                        </div>
                        <div class="followers">
                          {{ item.trader_data.followers }}
                          {{ item.trader_data.followers >= 1000 ? "K" : "" }}
                          Followers
                        </div>
                      </div>
                    </div>
                  </td>
                  <td v-if="item.trader_data">
                    <div class="name">
                      {{
                        item.trader_data
                          ? item.trader_data.closed_trades_count
                          : 0
                      }}
                    </div>
                  </td>
                  <td v-if="item.trader_data" class="name">
                    <span v-if="item.trader_data.percent">
                      {{ item.trader_data.percent }} %
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td v-if="item.trader_data" class="name">
                    <div v-if="item.trader_data.other_details">
                      <span
                        v-if="item.trader_data.other_details.holding_period"
                      >
                        {{ item.trader_data.other_details.holding_period }}
                        days
                      </span>
                      <span v-else> - </span>
                    </div>
                  </td>
                  <td class="" v-if="item.trader_data">
                    <div v-if="item.trader_data.other_details">
                      {{ item.trader_data.other_details.risk_reward || "-" }}
                    </div>
                  </td>
                  <td v-if="item.trader_data">
                    <div
                      v-if="item.trader_data.other_details"
                      :class="
                        returnRedGreen(
                          item.trader_data.other_details.avg_trade_return || 0
                        )
                      "
                    >
                      {{ item.trader_data.other_details.avg_trade_return || 0 }}
                    </div>
                  </td>
                  <td v-if="item.trader_data">
                    <div
                      :class="returnRedGreen(item.trader_data.days_pnl_percent)"
                    >
                      {{ Math.round(item.trader_data.days_pnl_percent) || 0 }}
                    </div>
                  </td>
                  <td>
                    <template v-if="item.trader_data">
                      <div
                        v-if="item.trader_data.followers_ids"
                        class="d-flex justify-end"
                      >
                        <v-btn
                          v-if="
                            !is_drag &&
                            !item.trader_data.followers_ids.includes(
                              commonFunctions.getUserId()
                            )
                          "
                          @click="followUser(item.trader_data.user_id)"
                          :loading="follow_loading[item.trader_data.user_id]"
                          small
                          style="border-radius: 5px"
                          width="5.75rem"
                          depressed
                          color="primary"
                          class="text-capitalize"
                        >
                          Follow
                        </v-btn>
                        <v-btn
                          v-else-if="
                            !is_drag &&
                            item.trader_data.followers_ids.includes(
                              commonFunctions.getUserId()
                            )
                          "
                          @click="unFollowUser(item.trader_data.user_id)"
                          :loading="unfollow_loading[item.trader_data.user_id]"
                          width="5.75rem"
                          style="border-radius: 5px"
                          small
                          outlined
                          depressed
                          color="primary"
                          class="text-capitalize"
                        >
                          Unfollow
                        </v-btn>

                        <div class="delete-btn">
                          <v-btn
                            v-if="is_drag"
                            @click="deleteButton(item.id)"
                            class="delete-button"
                            depressed
                          >
                            <v-icon> mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                  </td>
                </tr>
              </template>
            </draggable>
          </template>
        </v-data-table>
        <!-- <div
          class="text-center"
          v-if="hide && stock_data.length >= 10"
          v-intersect="onIntersects"
        >
          <v-progress-circular
            indeterminate
            color="#2f80ed"
          ></v-progress-circular>
          Loading More...
        </div> -->
      </draggable>
      <div v-if="stock_data.length != 0" class="text-center">
        <v-pagination
          v-model="pages"
          :length="total_page"
          circle
        ></v-pagination>
      </div>
    </div>
    <div v-else class="mb-13">
      <draggable
        class="list-group"
        group="trader-mobile-view"
        :list="stock_data"
        @start="drag = true"
        @change="ended"
        @end="drag = false"
        :options="{
          disabled: !is_drag,
          handle: '.drag-handle',
        }"
      >
        <!-- <transition-group> -->
        <div
          v-for="item in stock_data"
          class="list-group-item pt-2"
          :key="item.id"
        >
          <div :class="is_drag ? 'd-flex align-center' : ''">
            <div v-if="is_drag">
              <v-btn class="drag-handle" icon>
                <v-icon>mdi-drag </v-icon>
              </v-btn>
            </div>
            <v-card width="100%" class="">
              <v-card-title class="py-1 card-title">
                <div class="d-flex align-center">
                  <div class="outer-image">
                    <v-img
                      class="inner-image"
                      :src="
                        item.trader_data.profile_image
                          ? item.trader_data.profile_image
                          : default_profile_img
                      "
                    >
                    </v-img>
                  </div>
                  <div class="ml-2">
                    <div class="name d-flex justify-between align-center">
                      <span>
                        {{ item.trader_data.name || "N/A" }}
                      </span>
                      <div>
                        <v-img
                          v-if="item.trader_data.is_sebi_registered"
                          class="ml-1"
                          :src="verified"
                          width="14px"
                        ></v-img>
                      </div>
                    </div>
                    <div class="name">
                      {{ item.trader_data.followers || 0 }}

                      {{ item.trader_data.followers >= 1000 ? "K" : "" }}
                      <span class="followers">Followers</span>
                    </div>
                  </div>
                </div>
                <div v-if="item.trader_data.followers_ids">
                  <v-btn
                    v-if="
                      !is_drag &&
                      !item.trader_data.followers_ids.includes(
                        commonFunctions.getUserId()
                      )
                    "
                    @click="followUser(item.trader_data.user_id)"
                    :loading="follow_loading[item.trader_data.user_id]"
                    class="text-capitalize"
                    x-small
                    depressed
                    style="border-radius: 5px"
                    width="72px"
                    height="28px"
                    color="primary"
                  >
                    Follow
                  </v-btn>
                  <v-btn
                    v-else-if="
                      !is_drag &&
                      item.trader_data.followers_ids.includes(
                        commonFunctions.getUserId()
                      )
                    "
                    @click="unFollowUser(item.trader_data.user_id)"
                    :loading="unfollow_loading[item.trader_data.user_id]"
                    width="72px"
                    height="28px"
                    x-small
                    style="border-radius: 5px"
                    outlined
                    depressed
                    color="primary"
                    class="text-capitalize"
                  >
                    Unfollow
                  </v-btn>
                  <div class="delete-btn">
                    <v-btn
                      v-if="is_drag"
                      @click="deleteButton(item.id)"
                      class="delete-button"
                      depressed
                    >
                      <v-icon small> mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                  <!-- <v-btn
                    @click="followUser(item.trader_data.user_id)"
                    class="text-capitalize"
                    x-small
                    depressed
                    width="4.5rem"
                    color="primary"
                  >
                    Unfollow
                  </v-btn> -->
                </div>
              </v-card-title>
              <v-card-text class="pt-4 mt-2">
                <v-row>
                  <v-col cols="4">
                    <div class="name text-center">
                      {{
                        item.trader_data
                          ? item.trader_data.closed_trades_count
                          : 0
                      }}
                    </div>
                    <div class="followers text-center">CLosed Trades</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="name text-center">
                      <span v-if="item.trader_data.percent">
                        {{ item.trader_data.percent }} %
                      </span>
                      <span> - </span>
                    </div>
                    <div class="followers text-center">Accuracy</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="name text-center">
                      <span
                        v-if="item.trader_data.other_details.holding_period"
                      >
                        {{ item.trader_data.other_details.holding_period }}
                        days
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div class="followers text-center">Holding Period</div>
                  </v-col>
                </v-row>
                <v-row class="px-9 py-2">
                  <v-divider> </v-divider>
                </v-row>
                <v-row class="">
                  <v-col cols="4">
                    <div class="name text-center">
                      {{ item.trader_data.other_details.risk_reward || "-" }}
                    </div>
                    <div class="followers text-center">Risk Reward</div>
                  </v-col>
                  <v-col cols="4">
                    <div
                      :class="
                        returnRedGreen(
                          item.trader_data.other_details.avg_trade_return
                        )
                      "
                      class="name text-center"
                    >
                      {{
                        item.trader_data.other_details.avg_return >= 1
                          ? "+"
                          : ""
                      }}
                      <span
                        v-if="item.trader_data.other_details.avg_trade_return"
                      >
                        {{ item.trader_data.other_details.avg_trade_return }}
                        %
                      </span>
                      <span v-else> - </span>
                    </div>
                    <div class="followers text-center">Avg Trade Return</div>
                  </v-col>
                  <v-col cols="4">
                    <div
                      class="name text-center"
                      :class="returnRedGreen(item.trader_data.days_pnl_percent)"
                    >
                      {{ item.trader_data.days_pnl_percent >= 1 ? "+" : "" }}
                      {{ Math.round(item.trader_data.days_pnl_percent) }} %
                    </div>
                    <div class="followers text-center">ROI</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </div>
        <!-- </transition-group> -->
      </draggable>
      <div v-if="stock_data.length != 0" class="text-center mb-5 mt-1">
        <v-pagination
          v-model="pages"
          :length="total_page"
          circle
        ></v-pagination>
      </div>
    </div>
    <!-- :style="!$vuetify.breakpoint.xsOnly ? '' : 'visibility: none'" -->
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "TradersWatchListTable",
  props: {
    returnTabId: Number,
    is_drag: Boolean,
    stock_data: {
      type: Array,
      required: true,
    },
    total_page: {
      type: Number,
    },
    page: {
      type: Number,
    },
  },
  components: { draggable: () => import("vuedraggable") },

  data() {
    return {
      drag: false,
      // hide: true,
      pages: this.page,

      commonFunctions: commonFunctions,
      // is_drag: false,
      follow_loading: {},
      unfollow_loading: {},
      draggableEnabled: true,
      profile_img: require("@/assets/images/portrait_photo.jpg"),
      default_profile_img: require("@/assets/images/Default User.svg"),
      search_img: require("@/assets/images/SearchWatchlist.svg"),
      verified: require("@/assets/images/gold_check.svg"),
      hide: true,
      count: 1,

      headers: [
        {
          text: "Trader",
          align: "start",
          sortable: false,
          value: "name",
          class: "trade-header",
        },
        {
          text: "Closed Trades",
          value: "close_trades",
          sortable: false,
          class: "trade-header",
        },
        {
          text: "ACCURACY",
          value: "accuracy",
          sortable: false,
          class: "trade-header",
        },
        {
          text: "Holding Period",
          value: "holding_period",
          sortable: false,
          class: "trade-header",
        },
        {
          text: "risk/reward",
          value: "risk_reward",
          sortable: false,
          class: "trade-header",
        },
        { text: "Avg Return", value: "avg_return", class: "trade-header" },
        {
          text: "ROI",
          value: "roi",
          sortable: false,
          class: "trade-header",
        },
        {
          value: "action",
          align: "end",
          sortable: false,
          class: "trade-header",
        },
      ],
      security_data: [
        {
          name: "Sagar Patel",
          followers: 3444,
          close_trades: 12,
          accuracy: "60%",
          holding_period: 12,
          risk_reward: "1:3",
          avg_return: "123",
          roi: 13,
        },
        {
          name: "Prashant Yadav",
          followers: 3444,
          close_trades: 12,
          accuracy: "60%",
          holding_period: 12,
          risk_reward: "1:3",
          avg_return: "123",
          roi: 13,
        },
      ],
    };
  },

  computed: {
    activeHeaders() {
      return this.headers.filter((h) => {
        if (!this.is_drag && h.value === "lock") {
          return false;
        }
        return true;
      });
    },

    stocks_data() {
      return this.stock_data;
    },
  },
  watch: {
    stock_data() {
      if (this.stock_data.length <= 10) {
        this.hide = true;
        this.count = 1;
      }
    },
    pages() {
      this.eventBus.$emit("appendStocksTable", this.pages);
    },
  },
  methods: {
    print(data) {
      console.log("printedd", data);
    },
    onIntersects(entries) {
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.count <= this.total_page) {
            this.count += 1;
            this.eventBus.$emit("appendStocksTable", true);
            // this.stock_data = this.stock_data;
          } else {
            this.hide = false;
          }
        }
      });
    },

    onCloneCallback(item) {
      const cloneMe = JSON.parse(JSON.stringify(item));

      return cloneMe;
    },
    onMoveCallback(evt, originalEvent) {
      const item = evt.draggedContext.element;
      const itemIdx = evt.draggedContext.futureIndex;
      console.log("on Move callback", originalEvent, itemIdx);
      // console.log("onMoveCallback");

      if (item.locked) {
        return false;
      }

      return true;
    },
    onDropCallback(evt, originalEvent) {
      // console.log("onDropCallback");
      let id = this.stock_data[evt.newIndex];
      this.eventBus.$emit("stock_old_index", {
        new_index: evt.newIndex + 1,
        old_index: id.id,
        id: id.trader,
      });
      console.log("on drop call back", evt, originalEvent);
    },

    returnRedGreen(value) {
      return value < 0 ? "down" : "up";
    },
    ended(event) {
      // console.log(event);
      // console.log(event.moved.oldIndex);
      // console.log(event.moved.newIndex + 1);
      let id = this.stock_data[event.moved.newIndex];
      this.eventBus.$emit("stock_old_index", {
        new_index: event.moved.newIndex + 1,
        old_index: id.id,
        id: id.trader,
      });
    },
    deleteButton(item) {
      this.eventBus.$emit("delete-item", {
        item: item,
      });
    },
    followUser(to_follow_id, index) {
      this.$set(this.follow_loading, to_follow_id, true);
      console.log(index);
      const user_id = localStorage.getItem("user_id");
      const successHandler = () => {
        this.$logEvent("followed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_followed_profile");
        }
        this.eventBus.$emit("refresh-traders-list", {
          id: this.returnTabId,
        });
        this.$set(this.follow_loading, to_follow_id, false);
      };
      const data = {
        user_id: user_id,
        to_follow_id: to_follow_id,
      };
      const errorHandler = () => {};
      Axios.request_POST(
        "/api/follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    unFollowUser(to_unfollow_id) {
      this.$set(this.unfollow_loading, to_unfollow_id, true);

      const user_id = localStorage.getItem("user_id");
      const successHandler = () => {
        this.eventBus.$emit("refresh-traders-list", {
          id: this.returnTabId,
        });
        this.$set(this.unfollow_loading, to_unfollow_id, false);
      };
      const data = {
        user_id: user_id,
        to_unfollow_id: to_unfollow_id,
      };
      const errorHandler = () => {};
      Axios.request_POST(
        "/api/un-follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
};
</script>

<style>
.trade-header {
  color: var(--Button-Black, #283037);
  font-size: 0.895rem !important;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  text-transform: uppercase !important;
}
</style>
<style lang="scss" scoped>
.delete-btn > .v-btn:not(.v-btn--round).v-size--default {
  height: 37px;
  min-width: 46px;
  padding: 0px !important;
  background-color: #fff !important;
  border-radius: 0.375rem;
  border: 1px solid rgba(51, 51, 51, 0.8);
}
.down {
  color: var(--Red, #eb5757);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-transform: uppercase;
}
.up {
  color: var(--Green-2, #27ae60);
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-transform: uppercase;
}
.name {
  color: #333;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.followers {
  color: rgba(51, 51, 51, 0.6);
  font-family: Avenir;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.closed-trade {
}
@media only screen and (max-width: 768px) {
  .down {
    color: var(--Red, #eb5757) !important;
    font-family: Avenir;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    text-transform: uppercase;
  }
  .up {
    color: var(--Green-2, #27ae60) !important;
    font-family: Avenir;
    font-size: 0.75rem !important;
    font-style: normal !important;
    font-weight: 800 !important;
    line-height: normal;
    text-transform: uppercase !important;
  }
  .name {
    color: #333;
    font-family: Avenir;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }
  .followers {
    color: rgba(51, 51, 51, 0.6);
    font-family: Avenir;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }
  .inner-image {
    height: 36px;
    width: 36px;
    border-radius: 0.36288rem;
  }
  .card-title {
    background: #f1f1f7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // justify-content: center;
  }
  .delete-btn > .v-btn:not(.v-btn--round).v-size--default {
    height: 26px;
    min-width: 30px;
    padding: 0px !important;
    background-color: #fff !important;
    border-radius: 0.375rem;
    border: 1px solid rgba(51, 51, 51, 0.8);
  }
}

.sebi_icon {
  display: inline !important;
}
</style>
